import React from 'react';
import './Pagination.css';

function Pagination({ totalPages, currentPage, setCurrentPage, resultsPerPage, setResultsPerPage }) {
  const maxPageNumbersToShow = 5;

  // Handler for "First Page" button
  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  // Handler for "Previous Page" button
  const handlePreviousPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  // Handler for "Next Page" button
  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  // Handler for "Last Page" button
  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };

  // Handler for clicking on a page number
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Handler for "Jump to Page" dropdown
  const handleJumpToPage = (event) => {
    const page = Number(event.target.value);
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Handler for changing "Results Per Page"
  const handleResultsPerPageChange = (event) => {
    setResultsPerPage(Number(event.target.value));
    setCurrentPage(1); // Reset to first page when results per page change
  };

  // Generate page numbers to display
  const generatePageNumbers = () => {
    const pageNumbers = [];
    let startPage = Math.max(currentPage - 2, 1);
    let endPage = Math.min(startPage + maxPageNumbersToShow - 1, totalPages);

    if (endPage - startPage < maxPageNumbersToShow - 1) {
      startPage = Math.max(endPage - maxPageNumbersToShow + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return { pageNumbers, startPage, endPage };
  };

  const { pageNumbers, endPage } = generatePageNumbers();

  return (
    <div className="pagination">
      <button className="page-button" onClick={handleFirstPage} disabled={currentPage === 1}>
        &laquo;
      </button>
      <button className="page-button" onClick={handlePreviousPage} disabled={currentPage === 1}>
        &lsaquo;
      </button>
      {pageNumbers.map((number) => (
        <button
          key={number}
          className={`page-button ${currentPage === number ? 'active' : ''}`}
          onClick={() => handlePageClick(number)}
        >
          {number}
        </button>
      ))}
      {endPage < totalPages - 1 && <span className="ellipsis">...</span>}
      {endPage < totalPages && (
        <button
          className={`page-button ${currentPage === totalPages ? 'active' : ''}`}
          onClick={() => handlePageClick(totalPages)}
        >
          {totalPages}
        </button>
      )}
      <button className="page-button" onClick={handleNextPage} disabled={currentPage === totalPages}>
        &rsaquo;
      </button>
      <button className="page-button" onClick={handleLastPage} disabled={currentPage === totalPages}>
        &raquo;
      </button>
      {/* Jump to Page Dropdown */}
      <select
        className="jump-dropdown"
        value={currentPage}
        onChange={handleJumpToPage}
        aria-label="跳轉到頁面"
      >
        {[...Array(totalPages)].map((_, index) => (
          <option key={index + 1} value={index + 1}>
            第 {index + 1} 頁
          </option>
        ))}
      </select>
      {/* Results Per Page Dropdown */}
      <select
        className="results-per-page-dropdown"
        value={resultsPerPage}
        onChange={handleResultsPerPageChange}
        aria-label="每頁顯示的結果數量"
      >
        {[10, 20, 30, 40, 50, 100].map((value) => (
          <option key={value} value={value}>
            每頁 {value} 條
          </option>
        ))}
      </select>
    </div>
  );
}

export default Pagination;
